import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'app-setrole',
  templateUrl: './setrole.component.html',
  styleUrls: ['./setrole.component.css']
})
export class SetroleComponent implements OnInit {
  
   employee_code;
   emplyoeeCodeData;
  constructor(private route: ActivatedRoute,private adm : AdminService, private router: Router) { }
  clickStatus = false;
  alreadySubmit = false;

  userData = {
    employee_code : '',
    employee_name : ''
  }

  sendUserData = {
    employee_code : '',
    roll_id : ''
  }

  ngOnInit() {
    this.employee_code = this.route.snapshot.params.employee_code;
    this.emplyoeeCodeData = {
      employee_code: this.employee_code,
    }
    this.adm.getParticularUser(this.emplyoeeCodeData).subscribe(res=>{
      //console.log(res);
      this.userData.employee_code = res.user.employee_code;
      this.userData.employee_name = res.user.employee_name;
      this.sendUserData.employee_code = this.userData.employee_code;
      this.sendUserData.roll_id = res.user.roll_id;
   
  });
    
  }

  onSubmit(roleForm)
  {
    this.clickStatus = true;
    if(roleForm.valid)
    {
     this.alreadySubmit = true;
     //console.log(this.sendUserData);
     var setrole = this.adm.particularUserRoleSet(this.sendUserData).subscribe( res => {
      localStorage.setItem('role_msg',res.message);
      this.router.navigate(['/userList']);
     })
     
      
    }
   
   
  }

}



// WEBPACK FOOTER //
// ./src/app/setrole/setrole.component.ts